import { Table as BaseTable } from "antd";
import styled, { css } from "styled-components";

import color from "../_style/color";

const variants = {
  basic: css`
    .ant-table-thead > tr > th {
      background: ${color.light};
    }

    .ant-table-tbody > tr > td {
      padding: 8px 15px;
    }

    .ant-table-column-sorter {
      position: absolute;
      right: 0;
    }

    .ant-table-column-sorter-up,
    .ant-table-column-sorter-down {
      display: none;
    }

    .ant-table-thead th.ant-table-column-has-sorters:hover {
      background-color: unset;
    }

    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-up,
    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-down {
      display: block;
    }

    .ant-table-column-sorter-up.active,
    .ant-table-column-sorter-down.active {
      color: ${color.highempahis};
      display: block;
    }

    .ant-empty-image {
      display: none;
    }

    .ant-empty-normal {
      margin: unset;
    }

    .ant-table-ping-left .ant-table-cell-fix-left-last::after {
      box-shadow: unset;
    }

    .ant-table-container::after {
      content: unset;
    }

    .ant-pagination-prev {
      margin: unset;
    }
    .ant-pagination-item {
      display: none;
    }
  `,
};

const Table = styled(BaseTable).attrs((props) => ({
  variant: props.variant || "basic",
}))`
  ${({ variant }) => variants[variant]}
`;

export default Table;
